import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

interface IQuizSubmissionPayload {
  choice_id: string;
  is_correct: boolean;
  quiz_id: string;
  article_content_id: string;
  assignment_content_id: string;
  quiz_question_id: string;
}

const useChecksForUnderstandingSubmit = () => {
  const submitChecksForUnderstandingPostRequest = useCallback(
    (payload: IQuizSubmissionPayload) => {
      const requestConfig = {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json" },
      };

      return new Request(
        `${MONOLITH_ORIGIN}/api/v3/checks-for-understanding-quiz-submission/`,
        requestConfig,
      );
    },
    [],
  );
  return useRestMutation(submitChecksForUnderstandingPostRequest);
};

export default useChecksForUnderstandingSubmit;
